import merge from 'lodash/merge'
import buildGraphQLProvider from 'ra-data-graphql'
//import { defaultQueryValueToInputValueMap, ProviderOptions, buildQuery } from 'ra-postgraphile'

import { buildQuery } from '../node_modules/ra-postgraphile/build/module/buildQuery';
import { defaultQueryValueToInputValueMap } from '../node_modules/ra-postgraphile/build/module/defaultValueInputTypeMapping';

export default function (
  client,
  options,
  GqlOptions
) {
  return buildGraphQLProvider(
    merge(
      {
        client,
        buildQuery,
        options: merge(options, {
          queryValueToInputValueMap: defaultQueryValueToInputValueMap
        })
      },
      GqlOptions
    )
  )
}
